export interface WobbleSimulatorOptions {
  stiffness?: number;
  damping?: number;
}

export interface SlimeScale {
  scaleX: number;
  scaleY: number;
  scaleZ: number;
}

export class WobbleSimulator {
  public wobbleY: number = 0;
  public velocity: number = 0;
  public stiffness: number;
  public damping: number;

  constructor(options: WobbleSimulatorOptions = {}) {
    this.stiffness = options.stiffness ?? 120.0;
    this.damping = options.damping ?? 14.0;
  }

  public applyImpulse(impulse: number): void {
    this.wobbleY = Math.max(-0.6, Math.min(1.2, this.wobbleY + impulse));
    this.velocity += impulse * 4.0;
  }

  public update(dt: number): void {
    // Fixed or clamped delta time to prevent numerical explosion
    const step = Math.min(dt, 0.05);
    const acceleration = -this.stiffness * this.wobbleY - this.damping * this.velocity;
    this.velocity += acceleration * step;
    this.wobbleY += this.velocity * step;
    this.wobbleY = Math.max(-0.6, Math.min(1.2, this.wobbleY));
  }

  public getScale(): SlimeScale {
    const scaleY = Math.max(0.1, 1.0 + this.wobbleY);
    // Preserves volume: scaleX * scaleY * scaleZ = 1.0 => scaleX = scaleZ = sqrt(1 / scaleY)
    const scaleHorizontal = Math.sqrt(1.0 / scaleY);

    return {
      scaleX: scaleHorizontal,
      scaleY: scaleY,
      scaleZ: scaleHorizontal
    };
  }
}
